import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { toJS } from 'mobx';
import { sleep } from 'src/utils/sleep';
import { getRequiredTextMessage } from 'src/utils/formValidation';
import { ManageAccessForm } from 'src/components/shared/ManageAccessModal/ManageAccessForm';
export const GetForm = observer(_ref => {
  let existingPortfolio = _ref.existingPortfolio,
    isEditMode = _ref.isEditMode,
    handleModalClose = _ref.handleModalClose,
    triggerRefresh = _ref.triggerRefresh,
    isCreateAndMoveProperties = _ref.isCreateAndMoveProperties;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState((existingPortfolio === null || existingPortfolio === void 0 ? void 0 : existingPortfolio.name) || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    portfolioName = _useState4[0],
    setPortfolioName = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    portfolioNameTouched = _useState6[0],
    setPortfolioNameTouched = _useState6[1];
  const assignPropertiesToPortfolio = async _ref2 => {
    let targetPortfolioId = _ref2.targetPortfolioId,
      propertyIds = _ref2.propertyIds;
    return store.portfolios.transferPortfoliosAsync.run({
      targetPortfolioId: targetPortfolioId,
      propertyIds: propertyIds
    });
  };
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    grantedTeamMembersIds = _useState8[0],
    setGrantedTeamMembersIds = _useState8[1];
  const handleSubmit = async event => {
    event.stopPropagation();
    event.preventDefault();
    setIsLoading(true);
    if (!isEditMode || isCreateAndMoveProperties) {
      const resp = await store.portfolios.createPortfolioAsync.run({
        name: portfolioName
      });
      const createdPortfolioId = resp === null || resp === void 0 ? void 0 : resp.response;
      if (grantedTeamMembersIds && !!(grantedTeamMembersIds !== null && grantedTeamMembersIds !== void 0 && grantedTeamMembersIds.length)) {
        const assignResp = await store.account.assignResourceTeamMemberAsync.run({
          propertyId: null,
          portfolioId: createdPortfolioId,
          accountIds: grantedTeamMembersIds
        });
        if (assignResp && assignResp !== null && assignResp !== void 0 && assignResp.isSuccessful && !isCreateAndMoveProperties) {
          toast('success', {
            body: [t('general.successfully_saved')]
          });
        }
      }
      if (isCreateAndMoveProperties) {
        const assignPropertiesResp = await assignPropertiesToPortfolio({
          targetPortfolioId: createdPortfolioId,
          propertyIds: toJS(store.portfoliosMultiActionStore.selectedItems).map(i => i.propertyId)
        });
        if (resp !== null && resp !== void 0 && resp.isSuccessful && assignPropertiesResp !== null && assignPropertiesResp !== void 0 && assignPropertiesResp.isSuccessful) {
          toast('success', {
            body: [t('general.successfully_created')]
          });
          store.portfoliosMultiActionStore.deselectAll();
        }
      }
      if (resp !== null && resp !== void 0 && resp.isSuccessful && !isCreateAndMoveProperties && !(grantedTeamMembersIds && !!(grantedTeamMembersIds !== null && grantedTeamMembersIds !== void 0 && grantedTeamMembersIds.length))) {
        toast('success', {
          body: [t('general.successfully_saved')]
        });
      }
      await sleep(2000);
      setIsLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh({
        createdPortfolioId
      });
    } else {
      const resp = await store.portfolios.updatePortfolioAsync.run({
        portfolioId: existingPortfolio === null || existingPortfolio === void 0 ? void 0 : existingPortfolio.id,
        name: portfolioName
      });
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: [t('general.successfully_saved')]
        });
      }
      await sleep(2000);
      setIsLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh();
    }
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.inputLabel
  }, t('portfolios_properties_page.name_your_portfolio')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.inputPortfolioName, " ").concat(isEditMode ? classes.inputPortfolioNameEditMode : '')
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "portfolioName",
    name: "portfolioName",
    label: t('portfolios_properties_page.portfolio_name'),
    variant: "outlined",
    fullWidth: true,
    value: portfolioName,
    onFocus: () => setPortfolioNameTouched(true),
    onBlur: () => setPortfolioNameTouched(true),
    onChange: e => {
      setPortfolioNameTouched(true);
      setPortfolioName(e.target.value);
    },
    error: portfolioNameTouched && !portfolioName && !portfolioName.length,
    helperText: portfolioNameTouched && !portfolioName && !portfolioName.length && getRequiredTextMessage(t('portfolios_properties_page.portfolio_name'))
  })))), !isEditMode && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(ManageAccessForm
  // onSave
  , {
    portfolioData: existingPortfolio,
    hideFooter: true
    // noPadding
    ,
    disableMembersListScroll: true
    // triggerRefresh
    ,
    setGrantedTeamMembersIdsExternal: setGrantedTeamMembersIds
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '307-CreateEditPortfolio'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: handleSubmit,
    disabled: !portfolioName.length || isLoading,
    'custom-attribute': '308-CreateEditPortfolio'
  }, !!isEditMode ? t('general.save_and_close') : t('general.create')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});